module.exports = __webpack_public_path__ + "static/img/default-company-banner.89706057.jpg";